// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLeaf2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8.023 20.321C3.12 13.838 6.94 8.506 10.63 5.297c2.976-2.592 7.049-3.926 7.049-3.926s2.27 5.692.216 12.035c-2.38 7.279-6.953 7.313-9.87 6.915z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14.472 9.333S9.943 18.05 5.246 22.629"
    />
  </svg>
);
export default SvgLeaf2;
